/**
 * All of the CSS related to this component (and there's a fair amount because it uses CSS to animate) is in
 * sass/components/_loadingIndicator.scss.
 */
export default function LoadingIndicatorDirective($compile) {
  'ngInject';

  return {
    restrict: 'EA',
    link: function (scope, element, attr) {
      let loadingIndicator = $compile(
        `<div class="alert global-loading-indicator" ng-if="loader.isVisible">
           <div class="loader">Loading...</div>
         </div>`
      )(scope);

      element.append(loadingIndicator);
    },
    controller: function ($scope, LoadingIndicator) {
      'ngInject';

      $scope.loader = LoadingIndicator;
    }
  };
}
